import React, { useMemo } from 'react';
import { Filter } from 'lucide-react';

const FilterControls = ({
  dateRange,
  setDateRange,
  clientFilter,
  setClientFilter,
  projectTypeFilter,
  setProjectTypeFilter,
  calculations
}) => {
  const uniqueClients = useMemo(() => {
    if (!calculations) return [];
    const clients = [...new Set(calculations?.map(calc => calc?.userName)?.filter(Boolean))];
    return clients?.sort();
  }, [calculations]);

  return (
    <div className="bg-card border border-border rounded-lg p-4 sm:p-6 mb-6">
      <div className="flex items-center gap-2 mb-4">
        <Filter className="h-5 w-5 text-primary" />
        <h3 className="text-lg font-semibold text-foreground">Filtros</h3>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {/* Date Range Filter */}
        <div>
          <label className="block text-sm font-medium text-foreground mb-2">
            Período
          </label>
          <select
            value={dateRange}
            onChange={(e) => setDateRange(e?.target?.value)}
            className="w-full px-3 py-2 border border-border rounded-lg bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-primary"
          >
            <option value="month">Último Mês</option>
            <option value="quarter">Último Trimestre</option>
            <option value="year">Último Ano</option>
            <option value="all">Todos os Períodos</option>
          </select>
        </div>

        {/* Client Filter */}
        <div>
          <label className="block text-sm font-medium text-foreground mb-2">
            Cliente
          </label>
          <select
            value={clientFilter}
            onChange={(e) => setClientFilter(e?.target?.value)}
            className="w-full px-3 py-2 border border-border rounded-lg bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-primary"
          >
            <option value="all">Todos os Clientes</option>
            {uniqueClients?.map((client) => (
              <option key={client} value={client}>
                {client}
              </option>
            ))}
          </select>
        </div>

        {/* Project Type Filter - Placeholder for future implementation */}
        <div>
          <label className="block text-sm font-medium text-foreground mb-2">
            Tipo de Projeto
          </label>
          <select
            value={projectTypeFilter}
            onChange={(e) => setProjectTypeFilter(e?.target?.value)}
            className="w-full px-3 py-2 border border-border rounded-lg bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-primary"
          >
            <option value="all">Todos os Tipos</option>
          </select>
        </div>
      </div>
    </div>
  );
};

export default FilterControls;